export const getProjectsNavigationPaths = () => ({
	projectsViewProjects: '/jira/settings/projects/manage',
	projectsViewCategories: '/secure/admin/projectcategories/ViewProjectCategories!default.jspa',
	projectsTrashedProjects: '/jira/settings/projects/trash',
	projectsArchivedProjects: '/jira/settings/projects/archive',
});
